import { LiveGapController } from '@bufferController/GapController/LiveGapController';
import { VODGapController } from '@bufferController/GapController/VODGapController';
import { EDebuggableModuleState, IDebbugable, TDebuggableAdditionalInfo } from '@customTypes/common';
import { TEventBus } from '@eventBus/EventBus';

export class GapController implements IDebbugable {
  public _eventBus: TEventBus;

  public groups: string[] = ['buffer'];
  private _liveGapController: LiveGapController | null = null;
  private _vodGapController: VODGapController | null = null;
  private _videoElement: HTMLVideoElement | null = null;
  private _isInVODMode: boolean = false;

  constructor(eventBus: TEventBus) {
    this._eventBus = eventBus;
    this._liveGapController = new LiveGapController(this._eventBus);
    this._recreateGapController();
  }

  public destroy(): void {
    this._vodGapController?.destroy();
    this._liveGapController?.destroy();
  }

  public setIsVod(isVod: boolean): void {
    this._isInVODMode = isVod;
    this._recreateGapController();
  }

  public setVideoElement(videoElement: HTMLVideoElement): void {
    this._videoElement = videoElement;

    if (this._liveGapController) {
      this._liveGapController.setVideoElement(videoElement);
    }

    if (this._vodGapController) {
      this._vodGapController.setVideoElement(videoElement);
    }
  }

  public removeVideoElement(): void {
    this._videoElement = null;

    this._liveGapController?.removeVideoElement();
    this._vodGapController?.removeVideoElement();
  }

  private _recreateGapController(): void {
    this._vodGapController?.destroy();
    this._liveGapController?.destroy();

    if (this._isInVODMode) {
      this._vodGapController = new VODGapController(this._eventBus);
    } else {
      this._liveGapController = new LiveGapController(this._eventBus);
    }

    if (this._videoElement) {
      this.setVideoElement(this._videoElement);
    }
  }

  get status(): string {
    return this._vodGapController?.status || this._liveGapController?.status || 'Idle';
  }

  get state(): EDebuggableModuleState {
    return this._vodGapController?.state || this._liveGapController?.state || EDebuggableModuleState.OK;
  }

  get additionalInfo(): TDebuggableAdditionalInfo {
    return this._vodGapController?.additionalInfo || this._liveGapController?.additionalInfo || {};
  }
}
